import React, { useState } from "react";
import logo from "../../images/managekaro logo.png";
import RegisterSuccess from "../../images/RegisterSuccess.png";
import inventory from "../../images/inventory-main.png";
import {
  Dialog,
  DialogContent,
  FormControl,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { Grid, Stack, TextField, Typography } from "@mui/material";
import { useMediaQuery, useTheme, Box, styled, Button } from "@mui/material";
import { Link } from "react-router-dom";
import counterpart from "counterpart";
import eng from "../../lang/eng";
import urdu from "../../lang/urdu";
import { Redirect } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { yupResolver as yupResolver2 } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { auth } from "../../firebaseOTP";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import ClipLoader from "react-spinners/ClipLoader";
import UserRepository from "../../Repository/UserRepository";
import { BtnSelect } from "./style";
import { Toast } from "../../components/reusableComponents/ToastComp";
import Repo from "../../Repository/Repo";
import { countries } from "./CountriesList";
import ReactCountryFlag from "react-country-flag";
import { loadGoogleAnalytics } from "../analytics/analytics";
import CountrySelect from "./CountriesList";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const InventoryBox = styled(Box)({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  background: "#ffffff",
  height: "100vh",
});

const ReactHookForm = styled(TextField)({
  maxWidth: "100%",
  background: "#ffffff",
  borderRadius: "12px",
  marginLeft: "5px",
});

counterpart.registerTranslations("eng", eng);
counterpart.registerTranslations("urdu", urdu);

counterpart.setLocale("eng");

const phoneRegExp = /^(03)([0-9]{9})$/gm;

const schema2 = yup
  .object()
  .shape({
    newUser: yup.string().required("Name is Required"),
    companyCode: yup.number().required(),
  })
  .required();
const schema = yup
  .object()
  .shape({
    address: yup.string().required("Address is Required"),
    name: yup.string().required("Name is Required"),
    companyName: yup.string().required("Company Name is Required"),
    email: yup.string().email().required("Email is Required"),
    phone: yup.string().required(),
    password: yup
      .string()
      .required("Password id Required")
      .min(8, "Password is too short"),
    passwordVerification: yup
      .string()
      .required("Required")
      .oneOf([yup.ref("password"), null], "Passwords Not Matching"),
  })
  .required();

function Register() {
  const [id, setId] = useState(Number);
  const [name, setName] = useState("");
  const [verificationError, setVerificationError] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isLeft, setIsLeft] = useState(false);
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [userForm, setUserForm] = useState(false);
  const [adminForm, setAdminForm] = useState(true);
  const [registeredAdmin, setRegisteredAdmin] = useState(false);
  const [open, setOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [userData, setUserData] = useState("");
  const [verifyLoad, setVerifyLoad] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+92");
  const trackingId = "G-9JX2HR95FS";
  const country = localStorage.getItem("selectedCountry");
  console.log('countryyyyy', country)
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory()

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });
  const {
    reset: reset2,
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
  } = useForm({
    resolver: yupResolver2(schema2),
    mode: "onTouched",
  });

  if (localStorage.getItem("token") === !null) {
    return <Redirect to="/inventory" />;
  }

  const toggle = (data = "") => {
    setOpen((prev) => !prev);
    setUserData(data);
  };

  const registerAdmin = async (arg,eventLabel) => {
    console.log("arg:", arg);
    try {
      setLoading(true);
      setVerificationError("");
      // let phone = `${selectedCountry}${userData.phone}`;
      const { data } = await Repo.user({
        request: {
          method: "signupAdmin",
          data: {
            user: {
              company_name: arg.companyName,
              address: arg.address,
              phone: arg.phone,
              password: arg.password,
              email: arg.email,
              name: arg.name,
            },
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
      
        setLoading(false);
        // loadGoogleAnalytics(trackingId);

        // if (typeof gtag !== "undefined") {
        //   gtag("event", "registration_success", {
        //     event_category: "Registration",
        //     event_label: eventLabel,
        //     value: 1,
        //   });
        // }
        Toast("success", "Registered successfully");
        reset();
        setAdminForm(false);
        setRegisteredAdmin(true);
        // if (country !== "PK") {
        //   window.location.href = "https://managekaro-intl.web.app/inventory/login";
        // }
        
        
      } else {
        // if (typeof gtag !== "undefined") {
        //   gtag("event", "registration_failure", {
        //     event_category: "Registration",
        //     event_label: eventLabel,
        //     value: 1,
        //   });
        // }
        setVerificationError(data.response.status.statusDescription);
        setLoading(false);
      }
    } catch (err) {
    
      setLoading(false);
      // if (typeof gtag !== "undefined") {
      //   gtag("event", "registration_failure", {
      //     event_category: "Registration",
      //     event_label: eventLabel,
      //     value: 1,
      //   });
      // }
      console.log("err:", err);
      Toast("error", "Error");
    }
  };

  const userRegister = async (data) => {
    let username = data.newUser;
    let userid = Math.floor(Math.random() * 9000 + 1000);
    let Id = userid.toString();
    setName(data.newUser);
    setId(userid);
    const res = await UserRepository.usersModel({
      request: {
        method: "saveUser",
        data: {
          user: {
            username: username,
            _id: Id,
            company_code: data.companyCode.toString(),
          },
        },
      },
    });
    if (res.data.response.status.statusMessage == "OK") {
      setUserForm(false);
      setRegistered(true);
      setUserBtnClass("btn-gp-right");
      setCompanyName(res.data.response.data.user.company_name);
    } else {
      setVerificationError(res.data.response.status.statusDescription);
    }
    reset2();
  };

  const generateRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      "recaptcha",
      {
        size: "invisible",
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // ...
        },
      },
      auth
    );
  };

  const handleSend = (data) => {
    setLoading(true);
    setUserData(data);
    console.log("phone:");
    generateRecaptcha();
    let phone = `${selectedCountry}${data.phone}`;
    console.log("phone:", phone);
    let appVerifier = window.recaptchaVerifier;
    console.log("phone:", phone);
    signInWithPhoneNumber(auth, phone, appVerifier)
      .then((confirmationResult) => {
        console.log("test");
        setOpen(true);
        window.confirmationResult = confirmationResult;
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const onVerify = () => {
    setVerifyLoad(true);
    // verify otp
    let confirmationResult = window.confirmationResult;
    confirmationResult
      .confirm(otp)
      .then((result) => {
        setVerifyLoad(false);
        setOpen(false);
        registerAdmin();
      })
      .catch((error) => {
        console.log("error:", error);
        Toast("error", "Invalid otp code");
      });
  };

  const handleInput = (e) => {
    const { value } = e.target;
    setOtp(value);
  };

  const handleCountryChange = (e) => {
    const { value } = e.target;
    setSelectedCountry(value);
  };

  return (
    <div>
      <Grid container sx={{ width: "100%", height: "100vh" }}>
        <Grid item lg={6} md={6} sm={12}>
          <div style={{ textAlign: "center" }}>
            {adminForm && (
              <div style={{ marginTop: "50px" }}>
                <h2 style={{ color: "#4EAF50", fontWeight: "normal" }}>
                  Register new account!
                </h2>
                <h5 style={{ color: "#999999" }}>
                  Enter your credentials below
                </h5>
              </div>
            )}
            {/* {!registeredAdmin && !registered && (
              <div style={{ marginTop: "25px" }}>
                <BtnSelect
                  sx={{
                    borderRadius: "4px 0px 0px 4px",
                    background: isLeft
                      ? "#4EAF51 !important"
                      : "#999999 !important",
                  }}
                  onClick={() => {
                    setUserForm(true);
                    setAdminForm(false);
                    setIsLeft(true);
                    setVerificationError("");
                    reset();
                    reset2();
                  }}
                >
                  Employee
                </BtnSelect>
                <BtnSelect
                  sx={{
                    background: !isLeft
                      ? "#4EAF51 !important"
                      : "#999999 !important",
                  }}
                  onClick={() => {
                    setVerificationError("");
                    setUserForm(false);
                    setAdminForm(true);
                    setIsLeft(false);
                    reset();
                    reset2();
                  }}
                >
                  Admin
                </BtnSelect>
              </div>
            )} */}
            {/* {userForm && (
              <div
                className={"pmd"}
                style={{ paddingTop: "0", marginTop: "0px" }}
              >
                <h3 style={{ fontWeight: "normal", color: "red" }}>
                  {verificationError}
                </h3>

                <div style={{ marginBottom: "30px" }}>
                  <TextField
                    className="reg-text-field"
                    label="Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    {...register2("newUser")}
                  />
                  <Typography sx={{ color: "red" }}>
                    {errors2.newUser?.message}
                  </Typography>
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <TextField
                    className="reg-text-field"
                    label="Company Code"
                    type="number"
                    fullWidth
                    variant="outlined"
                    {...register2("companyCode")}
                  />
                  <Typography sx={{ color: "red" }}>
                    {errors2.companyCode && "Parent Company Code is Required"}
                  </Typography>
                </div>
                {loading ? (
                  <ClipLoader size={30} color="#4DAF51" loading={loading} />
                ) : (
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: "#4daf51",
                      textTransform: "none",
                      color: "white",
                    }}
                    onClick={handleSubmit2(userRegister)}
                  >
                    REGISTER
                  </Button>
                )}
              </div>
            )} */}

            {adminForm && (
              <div
                style={{
                  margin: "0px",
                  padding: "0px",
                  padding: "20px 5% 20px 5%",
                }}
              >
                <h3 style={{ fontWeight: "normal", color: "red" }}>
                  {verificationError}
                </h3>

                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item md={6} xs={12}>
                    <ReactHookForm
                      label="Admin Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      {...register("name")}
                    />
                    <Typography style={{ color: "red" }}>
                      {errors.name?.message}
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <ReactHookForm
                      label="Address"
                      type="text"
                      fullWidth
                      variant="outlined"
                      {...register("address")}
                    />
                    <Typography sx={{ color: "red" }}>
                      {errors.address?.message}
                    </Typography>
                  </Grid>
                  {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div style={{ marginBottom: "30px" }}>
                      <p
                        style={{
                          margin: "0px",
                          padding: "0px",
                          fontSize: "13px",
                        }}
                      >
                        *If Your Company Already Exists
                      </p>
                      <ReactHookForm
                        label="Company Code"
                        type="number"
                        fullWidth
                        variant="outlined"
                        {...register("registerCompanyCode")}
                      />
                    </div>
                  </Grid> */}
                  <Grid item xs={12}>
                    <ReactHookForm
                      label="Business Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      {...register("companyName")}
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                    <CountrySelect/>
                  </Grid> */}
                  <Grid item md={6} xs={12}>
                    {/* <div style={{ marginBottom: "30px" }}>
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 1,
                            marginLeft: "30px",
                          }}
                        >
                          <FormControl fullWidth sx={{ width: "fit-content" }}>
                            <Select
                              variant="outlined"
                              onChange={handleCountryChange}
                              defaultValue="+92"
                              sx={{
                                "& fieldset": { border: "none" },
                              }}
                            >
                              {countries.map((item, i) => {
                                return (
                                  <MenuItem key={i} value={item.mobile}>
                                    <Stack direction="row" alignItems="center">
                                      <ReactCountryFlag
                                        countryCode={item.code}
                                        svg
                                      />
                                      <Typography sx={{ ml: 1 }}>
                                        {item.mobile}
                                      </Typography>
                                    </Stack>
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>
                        <div style={{ width: "100%" }}>
                          <OutlinedInput
                            sx={{
                              pl: 0,
                              maxWidth: "100%",
                              background: "#ffffff",
                              ml: "5px",
                              width: "90%",
                              pl: "120px",
                            }}
                            type="number"
                            variant="outlined"
                            {...register("phone")}
                          />
                        </div>
                      </div>
                      <Typography style={{ color: "red" }}>
                        {errors.phone?.message}
                      </Typography>
                    </div> */}

                    <ReactHookForm
                      label="Phone"
                      fullWidth
                      // type="number"
                      variant="outlined"
                      {...register("phone")}
                    />

                    <Typography style={{ color: "red" }}>
                      {errors.phone?.message}
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <ReactHookForm
                      label="Email"
                      type="email"
                      fullWidth
                      variant="outlined"
                      {...register("email")}
                    />
                    <Typography style={{ color: "red" }}>
                      {errors.email?.message}
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <ReactHookForm
                      label="Password"
                      type="password"
                      fullWidth
                      variant="outlined"
                      {...register("password")}
                    />
                    <Typography sx={{ color: "red" }}>
                      {errors.password?.message}
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <ReactHookForm
                      label="Re-Enter Password"
                      type="password"
                      fullWidth
                      variant="outlined"
                      {...register("passwordVerification")}
                    />
                    <Typography sx={{ color: "red" }}>
                      {errors.passwordVerification?.message}
                    </Typography>
                  </Grid>
                </Grid>

                {loading ? (
                  <ClipLoader size={40} color="#4DAF51" loading={loading} />
                ) : (
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: "#4daf51",
                      textTransform: "none",
                      color: "white",
                      mt: 2,
                    }}
                    // onClick={handleSubmit(registerAdmin)}
                    onClick={() => {
                      // if (typeof gtag !== "undefined") {
                      //   gtag("event", "button_click", {
                      //     event_category: "Registration",
                      //     event_label: "Admin Registration Button",
                      //     value: 1,
                      //   });
                      // }
                      handleSubmit((data) => registerAdmin(data, "Admin Registration"))();
                    }}
                  >
                    REGISTER
                  </Button>
                )}
              </div>
            )}

            {registered && (
              <div className="register-confirmation">
                <h1 className="Title">REGISTERED!</h1>

                <h3>Your Name: {name}</h3>
                <h3>Your Company: {companyName}</h3>
                <h3>Your ID: {id}</h3>
                <p>
                  This is your new user name and ID. Please remember this ID
                  because it will be used for logging into the website.{" "}
                </p>
                <Link to="/inventory/login">
                  <Button
                    variant="outlined"
                    sx={{ textTransform: "none", color: "white" }}
                  >
                    Back to Login
                  </Button>
                </Link>
              </div>
            )}

            {registeredAdmin && (
              <div className="register-confirmation">
                <img
                  style={{ height: "300px", width: "400px" }}
                  src={RegisterSuccess}
                />
                <h1 style={{ color: "#4daf51" }}>Congratulations!</h1>
                {/* <h3>You are registered now</h3> */}
                <h3>Thankyou for your registration 😊</h3>
                {/* <h4>
                  Your account will soon be verified and you will receive
                  confirmation email.
                </h4> */}
                <Link to="/inventory/login">
                  <Button
                    variant="contained"
                    style={{ textTransform: "none", color: "white" }}
                  >
                    Back to Login
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </Grid>
        {!matches && (
          <Grid item lg={6} md={6} sm={12}>
            <InventoryBox>
              <img
                style={{ maxWidth: "150px", maxHeight: "150px" }}
                src={logo}
                alt="logo"
              />

              <h2
                style={{
                  fontWeight: "normal",
                  textAlign: "center",
                  color: "#4daf51",
                  margin: "20px",
                  fontSize: "25px",
                }}
              >
                The Best Solution For All Your Business Needs
              </h2>

              <img height="50%" width="50%" src={inventory} alt="logo" />
            </InventoryBox>
          </Grid>
        )}
      </Grid>

      <Dialog open={open} fullWidth maxWidth="xs">
        <DialogContent>
          <Stack spacing="16px" alignItems="center" justifyContent="center">
            <Typography sx={{ textAlign: "center" }}>
              OTP code has sent on your phone number
            </Typography>
            <Typography sx={{ textAlign: "center" }}>Enter OTP</Typography>
            <Box>
              <TextField
                size="small"
                label="OTP"
                type="number"
                variant="outlined"
                value={otp}
                onChange={handleInput}
              />
            </Box>
            <Stack
              direction="row"
              height="40px"
              width="100%"
              alignItems="center"
              justifyContent="space-around"
            >
              <Button
                variant="contained"
                sx={{
                  background: "#999999 !important",
                }}
                disabled={verifyLoad ? true : false}
                onClick={toggle}
              >
                Cancel
              </Button>
              {verifyLoad ? (
                <Stack width="64px" alignItems="center" justifyContent="center">
                  <ClipLoader size={30} color="#4DAF51" loading={verifyLoad} />
                </Stack>
              ) : (
                <Button variant="contained" onClick={onVerify}>
                  Verify
                </Button>
              )}
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>

      <div id="recaptcha"></div>
    </div>
  );
}

export default Register;
